import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  AUDIT_SUBMISSIONS_POST_FAILURE: 'AUDIT_SUBMISSIONS_POST_FAILURE',
  AUDIT_SUBMISSIONS_POST_REQUEST: 'AUDIT_SUBMISSIONS_POST_REQUEST',
  AUDIT_SUBMISSIONS_POST_SUCCESS: 'AUDIT_SUBMISSIONS_POST_SUCCESS',
};

export const actionCreators = {
  postRequest: (auditSubmission: any) => ({
    type: actionTypes.AUDIT_SUBMISSIONS_POST_REQUEST,
    payload: { auditSubmission },
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_SUBMISSIONS_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_SUBMISSIONS_POST_FAILURE,
  }),
  postSuccess: (auditSubmission: any) => ({
    type: actionTypes.AUDIT_SUBMISSIONS_POST_SUCCESS,
    payload: { auditSubmission },
  }),
  postFailure: (error) => ({
    type: actionTypes.AUDIT_SUBMISSIONS_POST_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
